import { useContext } from 'react';

import { MediaLibrarySearchQueryContext } from '~modules/media-library/context/MediaLibrarySearchQuery';

export default function useMediaLibrarySearchQuery() {
  const context = useContext(MediaLibrarySearchQueryContext);
  if (!context) {
    throw new Error(`useMediaLibrarySearchQuery must be used within a MediaLibrarySearchQueryProvider`);
  }
  return context;
}
